import type { SpontaneousApplicationSettings } from '@profilpublic/api-contract/career-site'
import {
  SPONTANEOUS_APPLICATION_TITLE_DEFAULT,
  createDefaultSpontaneousApplicationSettings,
  normalizeSpontaneousApplicationSettings
} from '@profilpublic/api-contract/career-site'

export type CareerSpontaneousApplicationsSource = {
  spontaneousApplicationTitle?: string | null
  spontaneousTypes?: unknown
}

export function resolveCareerSpontaneousApplications(source: CareerSpontaneousApplicationsSource): SpontaneousApplicationSettings {
  const defaults = createDefaultSpontaneousApplicationSettings()

  try {
    return normalizeSpontaneousApplicationSettings({
      title: source.spontaneousApplicationTitle || SPONTANEOUS_APPLICATION_TITLE_DEFAULT,
      spontaneousTypes: source.spontaneousTypes || defaults.spontaneousTypes
    })
  } catch {
    return defaults
  }
}
